// A launch begins only after the previous card has reached its player.
// Keeping the flight short prevents six-player, sixteen-card deals from
// blocking gameplay for an excessive amount of time.
export const DEAL_CARD_ANIMATION_MS = 220;
export const DEAL_CARD_INTERVAL_MS = 240;

// Participants retain their table indexes. Each round begins immediately
// after the starter and ends at the starter: B, C, A; B, C, A...
export const buildRoundRobinDealSequence = (participants, starterIndex, cardsPerPlayer) => {
    if (!participants.length || starterIndex < 0 || starterIndex >= participants.length) return [];
    const order = [...participants.slice(starterIndex + 1), ...participants.slice(0, starterIndex + 1)];
    return Array.from({ length: cardsPerPlayer }, (_, round) =>
        order.map((participant, dealIndex) => ({
            ...participant,
            round,
            sequence: round * order.length + dealIndex,
        }))).flat();
};
